import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import { ResourceTypeEnum } from '@/types/schema';

import { getContentImage } from '../utils';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Homework];

const config: ContentConfigProps = {
  routes: { details: () => '/', manageDetails: () => '/' },
  label: { title, createDescription },
  icons: {
    getContentImage,
  },
};

export default config;
